import React from "react";
import Layout from "./Layout";
import GitHubProjects from "../components/GitHubProjects";

export default function Projects() {
  return (
    <Layout>
      <GitHubProjects />
    </Layout>
  );
}